(() => {
  const name = 'concord-static-video-hero';
  if (customElements.get(name)) return;
  const previews = ['maxresdefault', 'sddefault', 'hqdefault', 'mqdefault', 'default'];

  customElements.define(name, class extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.image = this.querySelector('[data-concord-preview]');
      this.watch = this.querySelector('[data-concord-watch]');
      this.onImageLoad = () => {
        const index = Number(this.image.dataset.previewIndex);
        if (this.image.naturalWidth <= 120 && index < previews.length - 1) this.nextPreview();
      };
      this.onImageError = () => this.nextPreview();
      if (this.image) {
        this.image.addEventListener('load', this.onImageLoad);
        this.image.addEventListener('error', this.onImageError);
        if (this.image.complete) {
          if (this.image.naturalWidth) this.onImageLoad();
          else this.onImageError();
        }
      }
      this.onKey = event => {
        if (event.key === ' ') {
          event.preventDefault();
          if (!event.repeat) this.watch.click();
        }
      };
      this.onClick = () => {
        this.pendingClick = true;
        Promise.resolve().then(() => { this.pendingClick = false; });
      };
      this.onOpen = () => {
        this.ownsModal = Boolean(this.pendingClick || this.watch.getAttribute("aria-expanded") === "true");
        if (this.ownsModal) {
          clearTimeout(this.returnTimer);
          this.watch.setAttribute('aria-expanded', 'true');
        }
      };
      this.onClose = () => {
        if (!this.ownsModal) return;
        this.ownsModal = false;
        this.watch.setAttribute('aria-expanded', 'false');
        clearTimeout(this.returnTimer);
        this.returnTimer = setTimeout(() => {
          const modal = document.getElementById('VideoModal');
          if (this.isConnected && (!modal || !modal.classList.contains('modal--is-active'))) {
            this.watch.focus();
          }
        }, 550);
      };
      this.watch.addEventListener('keydown', this.onKey);
      this.watch.addEventListener('click', this.onClick, true);
      document.addEventListener('modalOpen.VideoModal', this.onOpen);
      document.addEventListener('modalClose.VideoModal', this.onClose);
    }

    nextPreview() {
      const index = Number(this.image.dataset.previewIndex) + 1;
      if (index >= previews.length) {
        this.image.hidden = true;
        return;
      }
      this.image.dataset.previewIndex = String(index);
      this.image.src = 'https://i.ytimg.com/vi/' + encodeURIComponent(this.image.dataset.videoId) + '/' + previews[index] + '.jpg';
    }

    disconnectedCallback() {
      this.connected = false;
      this.ownsModal = false;
      this.pendingClick = false;
      clearTimeout(this.returnTimer);
      if (this.image) {
        this.image.removeEventListener('load', this.onImageLoad);
        this.image.removeEventListener('error', this.onImageError);
      }
      if (this.watch) {
        this.watch.removeEventListener('keydown', this.onKey);
        this.watch.removeEventListener('click', this.onClick, true);
      }
      document.removeEventListener('modalOpen.VideoModal', this.onOpen);
      document.removeEventListener('modalClose.VideoModal', this.onClose);
    }
  });
})();
